import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

const propTypes = {
  cancelledAt: PropTypes.instanceOf(moment).isRequired,
};

const PastBookingInfoRefundNotice = ({ cancelledAt }) => {
  if (moment().diff(cancelledAt, 'days') > 5) {
    return null;
  }

  return <div className="grid-header weak">Allow 1-5 days to process</div>;
};

PastBookingInfoRefundNotice.propTypes = propTypes;
export default PastBookingInfoRefundNotice;
